// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AbcOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AbcOffIcon" ref={forwardedRef} {...props}>
      <path d="M14.925 13.066q-.665-.768-.79-2.06H13.23a2.5 2.5 0 0 1 .056.54 2.27 2.27 0 0 1-.32 1.203 2 2 0 0 1-.898.789c-.39.183-.85.27-1.379.27H7.902v-2.802h-1.57l.841 2.801H5.734l-.494-1.77H2.424l-.515 1.78H.5l.843-2.81H.5V9.504h18.98v1.501h-3.97q.098.676.414 1.078c.31.395.769.588 1.398.588.29 0 .56-.039.83-.126a2.5 2.5 0 0 0 .739-.365l.609 1.06a3.3 3.3 0 0 1-.999.567A3.6 3.6 0 0 1 17.272 14c-.999 0-1.778-.318-2.327-.953zm-5.694-2.06v1.55h1.288c.47 0 .83-.096 1.07-.298s.359-.491.359-.857a1.4 1.4 0 0 0-.053-.395z" />
      <path d="M15.646 8.003h-1.42q.193-.92.689-1.521c.54-.655 1.308-.982 2.327-.982a4.2 4.2 0 0 1 1.17.164 3.6 3.6 0 0 1 1.038.52L18.88 7.28a2.75 2.75 0 0 0-1.528-.462c-.64 0-1.109.202-1.418.616a2 2 0 0 0-.288.568" />
      <path d="M11.578 8.003h1.26a3 3 0 0 0 .009-.212c0-.655-.22-1.165-.65-1.54-.429-.366-1.048-.558-1.847-.558H7.902v2.31h1.329V6.934h1.188c.38 0 .66.097.86.28.2.192.3.462.3.78z" />
      <path d="m4.736 5.693.693 2.31H4.114L3.858 7.087 3.593 8.003H2.244l.693-2.31z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AbcOffIcon = /* @__PURE__ */ Object.assign(AbcOffIconComponent, {
  displayName: 'AbcOffIcon',
});
